module.exports = __webpack_public_path__ + "static/media/ic_visibility_off.1914078b.svg";